import {IUsefulLinkConfiguration} from "../configurations/config-data-sections/drawer.configuration";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {Check} from "@sparkware/app-utils";
import {AppIdentifiers, AreaType} from "@sparkware/uc-sdk-core";
import {SafeZoneDeeplink} from "../safezone/safezone.service.interface";
import {CHANNEL_SOURCE, CHANNEL_ELEMENTS} from "../../../common/const/casinofied-analytics-consts";


export default class UsefulLinkActions {
  private services: IServiceFactoryExtended;

  constructor(serviceFactory: IServiceFactoryExtended) {
    this.services = serviceFactory;
  }

  public executeAction(link: IUsefulLinkConfiguration) {
    // Handlers are instance methods of `this` named 'on[LinkId]'
    const handler = this._findHandler(link.id);
    if(handler) {
      handler.call(this, link);
    }
  }

  private _findHandler(linkId: string): (link: IUsefulLinkConfiguration) => void {
    if(!linkId || linkId.length < 1) {
      return null;
    }

    const handlerName = 'on' + linkId.charAt(0).toUpperCase() + linkId.slice(1);
    if(Check.isFunction(this[handlerName])) {
      return this[handlerName];
    }

    return null;
  }

  onTransactionHistory() {
    this.services.cashier.openTransactionHistory(
      {
        channel: {
          source: CHANNEL_SOURCE.casinoClient,
          area: AreaType.UserArea,
          element: CHANNEL_ELEMENTS.transactionHistoryButton 
        }
      }
    )
  }

  onTippingHistory(link: IUsefulLinkConfiguration) {
    this.services.location.push(link.link);
  }

  onReverseWithdrawal() {
    this.services.cashier.openOldCashier({sessionType: 6});
  }

  onUploadDocuments() {
    this.services.cashier.openOldCashier({sessionType: 20});
  }

  onCompPoints() {
    this.services.externalLinks.openMyAccount({tabId: 13});
  }

  onContactUs(link: IUsefulLinkConfiguration) {
    this.services.externalLinks.openContactUs({view: link.target});
  }

  onHelpCenter(link: IUsefulLinkConfiguration) {
    // If not enabled, we shouldn't show the link, but how do I do that?
    if (this.services.configuration.servicesConfigs.AppLauncher.apps.CR_HELP_CENTER.enabled) {
      this._openHelpWidget();
    } else {
      this.onContactUs(link);
    }
  }

  on888club(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onBeGambleAware(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onGameCare(link: IUsefulLinkConfiguration) {
    this._openLinkAction(link);
  }

  onSafeZone(link: IUsefulLinkConfiguration) {
    this.services.safezone.openFullSafezone();
  }

  onTimeSpentReminder(link: IUsefulLinkConfiguration) {
    this.services.safezone.openFullSafezone(SafeZoneDeeplink.TimeSpentReminderPage);
  }

  onHelp() {
    this.services.externalLinks.openHelpPage();
  }

  private _openHelpWidget() {
    this.services.appLauncher.openHelpWidget({
      businessCorrelationID: this.services.tools.getGuid(),
      channel: {
        area: AreaType.NavigationMenu,
        element: AppIdentifiers.CRHelpCenter,
        source: AppIdentifiers.CasinoClient
      }
    });
  }

  private _openLinkAction({local:shouldOpenLocal, link}: IUsefulLinkConfiguration){
    if(shouldOpenLocal) {
      this.services.location.push(link);
    } else {
      this.services.externalLinks.openLink({
        sourceLink: link,
        view: 'window'
      })
    }
  }
}
